import React, { useEffect, useState } from 'react';
import moment from "moment";
import { getMessage } from "CONFIG/i18n";

const WaitingTimeSection = (props) => {

  const getWaitingTime = (sessionCreatedTime) => {
    const duration = moment.duration(moment().diff(sessionCreatedTime));
    return [Math.floor(duration.asMinutes()), duration.seconds()];
  };

  const [waitingTime, setWaitingTime] = useState(getWaitingTime(props.sessionCreatedTime));

  useEffect(() => {
    const timerId = setInterval(() => {
      setWaitingTime(getWaitingTime(props.sessionCreatedTime));
    }, 1000);

    return () => clearInterval(timerId);
  }, [props.sessionCreatedTime]);

  return(
    <div className="subText">
      {getMessage("WAITING_TIME_MINUTES_SECONDS",
        { minutes: waitingTime[0], seconds: waitingTime[1] })}
    </div>
  );
};

export default WaitingTimeSection;